<template>
  <b-alert v-if="isOrganizationAdmin && count > 0" show variant="warning" class="text-left">
    {{ count === 1 ? '1 runner has' : `${count} runners have` }} no team and won't receive workouts.
    <!-- Users and Teams, filtered to these runners, has both the teams and the Active switch -->
    <router-link :to="usersAndTeams">Assign them to a team or deactivate them</router-link>.
  </b-alert>
</template>

<script>
import GlobalDataMixin from "@/components/GlobalDataMixin";

/**
 * Warns the Owners and Admins of the current organization about active runners with no team: they don't receive published
 * workouts. Inactive runners aren't counted.
 */
export default {
  name: 'RunnersWithoutTeamsAlert',
  mixins: [GlobalDataMixin],
  props: {
    globalData: Object,
  },
  data() {
    return {
      count: 0,
      usersAndTeams: {name: 'users-and-teams', query: {filter: 'true'}},
    }
  },
  computed: {
    organizationUuid() {
      return this.globalData && this.globalData.currentOrganization ? this.globalData.currentOrganization.uuid : null;
    },
  },
  watch: {
    // The roles arrive after the page, and the organization can change
    organizationUuid() {
      this.refresh();
    },
    isOrganizationAdmin() {
      this.refresh();
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (!this.isOrganizationAdmin || !this.organizationUuid) {
        this.count = 0;
        return;
      }
      this.$http.get('/api/admin/users-without-teams')
          .then(response => {
            this.count = response.data.length;
          })
          .catch(e => {
            console.warn(e)
          })
    },
  },
}
</script>
